import { FindUserBy } from '@app/shared/types/admin/common';

export const FIND_USER_PLACEHOLDERS_MAP: Record<FindUserBy, string> = {
  [FindUserBy.TELEGRAM_TAG]: 'telegram_tag_placeholder',
  [FindUserBy.TELEGRAM_ID]: 'telegram_id',
  [FindUserBy.USER_ID]: 'user_id',
};

export const FIND_USER_OPTIONS: { value: FindUserBy; translationKey: string }[] = [
  { value: FindUserBy.TELEGRAM_TAG, translationKey: 'telegram_tag' },
  { value: FindUserBy.TELEGRAM_ID, translationKey: 'telegram_id' },
  { value: FindUserBy.USER_ID, translationKey: 'user_id' },
];

export const PAGE_SIZE = 10;
